import type { SchoolBranchesJson } from '../services/api';

const BRANCH_ARRAY_KEYS = [
  'branches',
  'branch_list',
  'items',
  'data',
  'results',
  'list',
  'values',
  'children',
];

export function isPlainObject(v: unknown): v is Record<string, unknown> {
  return v !== null && typeof v === 'object' && !Array.isArray(v);
}

export function branchesToRows(data: SchoolBranchesJson | null | undefined): unknown[] {
  if (data == null) return [];
  if (Array.isArray(data)) return data;
  const rec = data as Record<string, unknown>;
  for (const key of BRANCH_ARRAY_KEYS) {
    const v = rec[key];
    if (Array.isArray(v)) return v;
  }
  if (rec.id != null && (typeof rec.name === 'string' || typeof rec.code === 'string')) {
    return [rec];
  }
  return [];
}

export function branchIdFromRow(row: unknown): string {
  if (!isPlainObject(row)) return '';
  const id = row.id ?? row.branch_id;
  return id != null ? String(id) : '';
}

export function branchNameFromRow(row: unknown): string {
  if (!isPlainObject(row)) return '';
  const name = row.name ?? row.branch_name;
  return typeof name === 'string' ? name.trim() : '';
}

export function branchIsHeadquarters(row: unknown): boolean {
  if (!isPlainObject(row)) return false;
  return Boolean(row.is_headquarters ?? row.is_main ?? row.is_head_office);
}

export function branchIsCurrent(row: unknown): boolean {
  if (!isPlainObject(row)) return false;
  return Boolean(row.is_current);
}

export function orgTypeLabel(orgType: string | null | undefined): string {
  const t = (orgType ?? '').trim().toLowerCase();
  if (t === 'school_branch' || t === 'branch') return 'Sub-campus';
  if (t === 'school') return 'Main campus';
  if (t === 'college') return 'College';
  return 'Campus';
}

export interface BranchOption {
  id: string;
  name: string;
}

export function branchOptionsFromRows(rows: unknown[]): BranchOption[] {
  return rows
    .map((row) => ({ id: branchIdFromRow(row), name: branchNameFromRow(row) }))
    .filter((b) => b.id && b.name);
}
